import { useEffect, useState } from "react";
import { motion, useMotionValue, useTransform } from "framer-motion";

const QUERY = "(max-width: 767px)";

export function useIsMobile() {
  const [mobile, setMobile] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const on = (e) => setMobile(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return mobile;
}

const Reveal = ({ side, label, opacity }) => (
  <motion.div style={{ opacity }} className={`absolute inset-0 flex items-center px-6 text-[0.65rem] tracking-[0.22em] uppercase font-semibold rounded-[inherit] ${
    side === "right" ? "justify-start bg-[#1E3A8A] text-white" : "justify-end bg-[#C6A55C] text-[#0F1D3D]"}`}>
    {label}
  </motion.div>
);

export default function SwipeCard({ children, right, left, testId }) {
  const mobile = useIsMobile();
  const x = useMotionValue(0);
  const rightOpacity = useTransform(x, [0, 70], [0, 1]);
  const leftOpacity = useTransform(x, [-70, 0], [1, 0]);
  if (!mobile || (!right && !left)) return children;
  const end = (_, info) => {
    if (info.offset.x > 90 && right) right.action();
    else if (info.offset.x < -90 && left) left.action();
  };
  return (
    <div className="relative rounded-[16px]" data-testid={testId}>
      {right && <Reveal side="right" label={right.label} opacity={rightOpacity} />}
      {left && <Reveal side="left" label={left.label} opacity={leftOpacity} />}
      <motion.div drag="x" dragDirectionLock dragSnapToOrigin dragConstraints={{ left: 0, right: 0 }}
        dragElastic={{ left: left ? 0.5 : 0, right: right ? 0.5 : 0 }} onDragEnd={end}
        style={{ x, touchAction: "pan-y" }} className="relative">
        {children}
      </motion.div>
    </div>
  );
}
